import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActiveAdminInfo } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ActiveAdminService {
  private readonly activeAdminSubject = new BehaviorSubject<ActiveAdminInfo>(null);
  public activeAdmin$: Observable<ActiveAdminInfo> = this.activeAdminSubject.asObservable();

  setActiveAdmin = (adminUser: ActiveAdminInfo): void => this.activeAdminSubject.next(adminUser);

  clearActiveAdmin = () => this.activeAdminSubject.next(null);
}
